<template>
  <svg
    class="icon-base fill-current"
    viewBox="0 0 16 12"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.5 0H1.5C0.671562 0 0 0.671562 0 1.5V10.5C0 11.3284 0.671562 12 1.5 12H14.5C15.3284 12 16 11.3284 16 10.5V1.5C16 0.671562 15.3284 0 14.5 0ZM14.3125 10.5H1.6875C1.63777 10.5 1.59008 10.4802 1.55492 10.4451C1.51975 10.4099 1.5 10.3622 1.5 10.3125V1.6875C1.5 1.63777 1.51975 1.59008 1.55492 1.55492C1.59008 1.51975 1.63777 1.5 1.6875 1.5H14.3125C14.3622 1.5 14.4099 1.51975 14.4451 1.55492C14.4802 1.59008 14.5 1.63777 14.5 1.6875V10.3125C14.5 10.3622 14.4802 10.4099 14.4451 10.4451C14.4099 10.4802 14.3622 10.5 14.3125 10.5ZM4 2.75C3.30966 2.75 2.75 3.30966 2.75 4C2.75 4.69034 3.30966 5.25 4 5.25C4.69034 5.25 5.25 4.69034 5.25 4C5.25 3.30966 4.69034 2.75 4 2.75ZM3 9H13V6.5L10.2652 3.76516C10.1187 3.61872 9.88128 3.61872 9.73481 3.76516L6 7.5L4.76516 6.26516C4.61872 6.11872 4.38128 6.11872 4.23481 6.26516L3 7.5V9Z"
    />
  </svg>
</template>
